import { EventEmitter } from 'eventemitter3';
const createNavigationStore = () => {
    let state = {
        navigationItems: [],
        userMenuItems: [],
    };
    const eventEmitter = new EventEmitter();
    return {
        getSnapshot: () => state,
        subscribe: (callback) => {
            eventEmitter.addListener('update', callback);
            return () => {
                eventEmitter.removeListener('update', callback);
            };
        },
        addNavigationItem: (item) => {
            state = {
                ...state,
                navigationItems: [...state.navigationItems, item].sort((a, b) => (a.priority ?? 100) - (b.priority ?? 100)),
            };
            eventEmitter.emit('update');
        },
        addUserMenuItem: (item) => {
            state = {
                ...state,
                userMenuItems: [...state.userMenuItems, item]
                    // default to visible if isVisible is not set
                    .filter(x => x.isVisible || x.isVisible == null || x.isVisible === undefined)
                    .sort((a, b) => (a.priority ?? 100) - (b.priority ?? 100)),
            };
            eventEmitter.emit('update');
        },
        getNavigationItems: () => state.navigationItems,
        getUserMenuItems: () => state.userMenuItems,
    };
};
export const navigationStore = createNavigationStore();
export const addNavigationItem = (navigationItem) => {
    navigationStore.addNavigationItem(navigationItem);
};
export const addUserMenuItem = (userMenuItem) => {
    navigationStore.addUserMenuItem(userMenuItem);
};
